import React from 'react';
import { Building, CreditCard, Shield, Bell, Users } from 'lucide-react';
export function Settings() {
  return <div className="space-y-8 animate-in fade-in duration-500 max-w-4xl" data-id="element-2313" data-mp="2j8jss1bvkn98">
      <div data-id="element-2314" data-mp="24ahr5woembum">
        <h1 className="text-2xl font-semibold text-slate-900" data-id="element-2315" data-mp="24b17xa2biu72">Settings</h1>
        <p className="text-slate-500 mt-1" data-id="element-2316" data-mp="299cdv9phskk0">
          Manage your organization and personal preferences.
        </p>
      </div>

      <div className="flex flex-col md:flex-row gap-8" data-id="element-2317" data-mp="2wyncolna84vi">
        {/* Settings Nav */}
        <div className="w-full md:w-64 shrink-0" data-id="element-2318" data-mp="31yjdyd4lhi7d">
          <nav className="space-y-1" data-id="element-2319" data-mp="31x8egpi6mwm2">
            <a href="#" className="flex items-center px-3 py-2.5 bg-slate-100 text-slate-900 rounded-md text-sm font-medium" data-id="element-2320" data-mp="2n9dkz6wcoo7x">
              <Building className="h-4 w-4 mr-3 text-slate-700" data-id="element-2321" data-mp="2s63vlepdyrly" />
              Organization
            </a>
            <a href="#" className="flex items-center px-3 py-2.5 text-slate-600 hover:bg-slate-50 hover:text-slate-900 rounded-md text-sm font-medium transition-colors" data-id="element-2322" data-mp="3fvy7nu1vsc55">
              <Users className="h-4 w-4 mr-3 text-slate-400" data-id="element-2323" data-mp="3j8pp0efs5jyb" />
              Members & Roles
            </a>
            <a href="#" className="flex items-center px-3 py-2.5 text-slate-600 hover:bg-slate-50 hover:text-slate-900 rounded-md text-sm font-medium transition-colors" data-id="element-2324" data-mp="1ry7lq6b4h2w">
              <Shield className="h-4 w-4 mr-3 text-slate-400" data-id="element-2325" data-mp="as3d1urxx5ef" />
              Permissions
            </a>
            <a href="#" className="flex items-center px-3 py-2.5 text-slate-600 hover:bg-slate-50 hover:text-slate-900 rounded-md text-sm font-medium transition-colors" data-id="element-2326" data-mp="5ukzts6w440m">
              <Bell className="h-4 w-4 mr-3 text-slate-400" data-id="element-2327" data-mp="ftakttu324l3" />
              Notifications
            </a>
            <a href="#" className="flex items-center px-3 py-2.5 text-slate-600 hover:bg-slate-50 hover:text-slate-900 rounded-md text-sm font-medium transition-colors" data-id="element-2328" data-mp="2mj8dvjy135p8">
              <CreditCard className="h-4 w-4 mr-3 text-slate-400" data-id="element-2329" data-mp="3792maeh9apoh" />
              Billing & Plans
            </a>
          </nav>
        </div>

        {/* Settings Content */}
        <div className="flex-1 space-y-6" data-id="element-2330" data-mp="3g74pn0ogpuex">
          <div className="bg-white border border-slate-200 rounded-xl shadow-sm overflow-hidden" data-id="element-2331" data-mp="3gaiucfklmfpj">
            <div className="p-6 border-b border-slate-200" data-id="element-2332" data-mp="3l4whjup3xgj4">
              <h2 className="text-lg font-medium text-slate-900" data-id="element-2333" data-mp="3q5kib8351bqj">
                Organization Profile
              </h2>
              <p className="text-sm text-slate-500 mt-1" data-id="element-2334" data-mp="3u64heh79upfb">
                Update your company details and branding.
              </p>
            </div>
            <div className="p-6 space-y-6" data-id="element-2335" data-mp="7sw3obgg41vq">
              <div className="flex items-center space-x-6" data-id="element-2336" data-mp="7rl12eyql067">
                <div className="w-20 h-20 bg-slate-100 border border-slate-200 rounded-lg flex items-center justify-center text-slate-400" data-id="element-2337" data-mp="cs8rozj1zezw">
                  <Building className="h-8 w-8" data-id="element-2338" data-mp="hqsdmzxncqs9" />
                </div>
                <div data-id="element-2339" data-mp="229mi8j803ncq">
                  <button className="bg-white border border-slate-200 text-slate-700 px-3 py-1.5 rounded-md text-sm font-medium hover:bg-slate-50 transition-colors" data-id="element-2340" data-mp="229w6o2dedmgb">
                    Upload Logo
                  </button>
                  <p className="text-xs text-slate-500 mt-2" data-id="element-2341" data-mp="1sc88t3khvytx">
                    JPG, GIF or PNG. 1MB max.
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-1 gap-6" data-id="element-2342" data-mp="2kyaxaojsyygl">
                <div data-id="element-2343" data-mp="2fzg731jia7mg">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-2344" data-mp="2g1ar8dmydvph">
                    Organization Name
                  </label>
                  <input type="text" defaultValue="Acme Corp" className="w-full px-3 py-2 border border-slate-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-slate-900 focus:border-slate-900 sm:text-sm" data-id="element-2345" data-mp="26a6c9dxa2aun" />
                </div>
                <div data-id="element-2346" data-mp="2jgawx0jt1mcu">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-2347" data-mp="2jg165aqxrb63">
                    Industry
                  </label>
                  <select className="w-full px-3 py-2 border border-slate-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-slate-900 focus:border-slate-900 sm:text-sm bg-white" data-id="element-2348" data-mp="2odkj87bwdhwg">
                    <option data-id="element-2349" data-mp="2eju0lj2gc1oo">Technology</option>
                    <option data-id="element-2350" data-mp="327235t8hwwn0">Healthcare</option>
                    <option data-id="element-2351" data-mp="329etatoeqdb5">Finance</option>
                    <option data-id="element-2352" data-mp="376og01kewava">Manufacturing</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="bg-slate-50 px-6 py-4 border-t border-slate-200 flex justify-end" data-id="element-2353" data-mp="2sgzaxv977mpq">
              <button className="bg-slate-900 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-slate-800 transition-colors" data-id="element-2354" data-mp="2xf0uehajdo1q">
                Save Changes
              </button>
            </div>
          </div>

          <div className="bg-white border border-slate-200 rounded-xl shadow-sm overflow-hidden" data-id="element-2355" data-mp="3pyzg5nnolupp">
            <div className="p-6 border-b border-slate-200" data-id="element-2356" data-mp="1efuifx19r6wz">
              <h2 className="text-lg font-medium text-slate-900" data-id="element-2357" data-mp="19ht41pesfvru">
                Subscription Plan
              </h2>
              <p className="text-sm text-slate-500 mt-1" data-id="element-2358" data-mp="1o77el0u3oj8t">
                Manage your current tier and features.
              </p>
            </div>
            <div className="p-6" data-id="element-2359" data-mp="vitbw7s2gyqx">
              <div className="flex items-center justify-between p-4 border border-indigo-100 bg-indigo-50 rounded-lg" data-id="element-2360" data-mp="vjupaiwk1xbt">
                <div data-id="element-2361" data-mp="qlt7e1av841x">
                  <div className="font-semibold text-indigo-900" data-id="element-2362" data-mp="qmbclnfi9slz">
                    Enterprise Tier
                  </div>
                  <div className="text-sm text-indigo-700 mt-1" data-id="element-2363" data-mp="10hmtabah59wd">
                    Includes AI Coaching & Benchmarking
                  </div>
                </div>
                <button className="bg-white border border-indigo-200 text-indigo-700 px-4 py-2 rounded-md text-sm font-medium hover:bg-indigo-50 transition-colors" data-id="element-2364" data-mp="2g0ra5r8exv66">
                  Manage Plan
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}